// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file morfi/v1/markets/trading.proto (package morfi.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EventMetadata, GiftKind, Side } from "../common_pb.js";
import { file_morfi_v1_common } from "../common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file morfi/v1/markets/trading.proto.
 */
export const file_morfi_v1_markets_trading: GenFile = /*@__PURE__*/
  fileDesc("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", [file_morfi_v1_common]);

/**
 * @generated from message morfi.v1.TradeEvent
 */
export type TradeEvent = Message<"morfi.v1.TradeEvent"> & {
  /**
   * @generated from field: morfi.v1.EventMetadata meta = 1;
   */
  meta?: EventMetadata | undefined;

  /**
   * 32 bytes
   *
   * @generated from field: bytes market = 2;
   */
  market: Uint8Array;

  /**
   * 32 bytes
   *
   * @generated from field: bytes bc = 3;
   */
  bc: Uint8Array;

  /**
   * @generated from field: uint32 outcome_index = 4;
   */
  outcomeIndex: number;

  /**
   * 32 bytes
   *
   * @generated from field: bytes outcome_mint = 5;
   */
  outcomeMint: Uint8Array;

  /**
   * 32 bytes
   *
   * @generated from field: bytes trader = 6;
   */
  trader: Uint8Array;

  /**
   * @generated from field: morfi.v1.Side side = 7;
   */
  side: Side;

  /**
   * @generated from field: uint64 quote_amount_gross = 8;
   */
  quoteAmountGross: bigint;

  /**
   * @generated from field: uint64 base_fee_to_backers = 9;
   */
  baseFeeToBackers: bigint;

  /**
   * @generated from field: uint64 base_fee_to_platform = 10;
   */
  baseFeeToPlatform: bigint;

  /**
   * @generated from field: uint64 prize_pool_contribution = 11;
   */
  prizePoolContribution: bigint;

  /**
   * @generated from field: uint64 bc_amount = 12;
   */
  bcAmount: bigint;

  /**
   * @generated from field: uint64 bc_supply_after = 13;
   */
  bcSupplyAfter: bigint;

  /**
   * @generated from field: bool used_penalty_fee = 14;
   */
  usedPenaltyFee: boolean;

  /**
   * chain time from program's Clock::get(); TimescaleDB hypertable partition column
   *
   * @generated from field: int64 ts = 15;
   */
  ts: bigint;

  /**
   * exactly n_outcomes values, outcome-index ordered
   *
   * @generated from field: repeated uint32 post_outcome_conviction_ppb = 16;
   */
  postOutcomeConvictionPpb: number[];

  /**
   * exactly n_outcomes values, outcome-index ordered
   *
   * @generated from field: repeated uint32 post_outcome_conviction_target_ppb = 17;
   */
  postOutcomeConvictionTargetPpb: number[];

  /**
   * @generated from field: uint32 post_conviction_retention_per_second_ppb = 18;
   */
  postConvictionRetentionPerSecondPpb: number;

  /**
   * @generated from field: int64 post_last_conviction_update_ts = 19;
   */
  postLastConvictionUpdateTs: bigint;

  /**
   * traded outcome only: virtual quote + real quote reserves after the trade
   *
   * @generated from field: uint64 post_quote_reserves = 20;
   */
  postQuoteReserves: bigint;

  /**
   * Market-wide: sum of real quote reserves across active outcomes after the trade.
   *
   * @generated from field: uint64 post_market_real_quote_reserves_d6 = 21;
   */
  postMarketRealQuoteReservesD6: bigint;
};

/**
 * Describes the message morfi.v1.TradeEvent.
 * Use `create(TradeEventSchema)` to create a new message.
 */
export const TradeEventSchema: GenMessage<TradeEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 0);

/**
 * Typed realtime payload for `morfi.market.{market}.user.{user}.trade.v0`.
 * The market is carried by the subject, so it is intentionally omitted here.
 *
 * @generated from message morfi.v1.MarketTrade
 */
export type MarketTrade = Message<"morfi.v1.MarketTrade"> & {
  /**
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: morfi.v1.Side side = 3;
   */
  side: Side;

  /**
   * @generated from field: string actor = 4;
   */
  actor: string;

  /**
   * @generated from field: uint64 amount_d6 = 5;
   */
  amountD6: bigint;

  /**
   * Traded outcome only: virtual quote + real quote reserves after the trade
   * (TradeEvent.post_quote_reserves). Same wire tag as the former
   * `post_reserves_d6` name — v0 subject unchanged.
   *
   * @generated from field: uint64 post_bc_quote_reserves_d6 = 6;
   */
  postBcQuoteReservesD6: bigint;

  /**
   * Market-wide: sum of real quote reserves across active outcomes after the trade
   * (TradeEvent.post_market_real_quote_reserves_d6).
   *
   * @generated from field: uint64 post_market_real_quote_reserves_d6 = 7;
   */
  postMarketRealQuoteReservesD6: bigint;

  /**
   * @generated from field: uint32 outcome_idx = 8;
   */
  outcomeIdx: number;

  /**
   * @generated from field: repeated uint32 post_outcome_conviction_ppb = 9;
   */
  postOutcomeConvictionPpb: number[];

  /**
   * @generated from field: repeated uint32 post_outcome_conviction_target_ppb = 10;
   */
  postOutcomeConvictionTargetPpb: number[];

  /**
   * @generated from field: uint32 post_conviction_retention_per_second_ppb = 11;
   */
  postConvictionRetentionPerSecondPpb: number;

  /**
   * @generated from field: uint64 prize_pool_contribution_d6 = 12;
   */
  prizePoolContributionD6: bigint;

  /**
   * @generated from field: string signature = 13;
   */
  signature: string;

  /**
   * @generated from field: optional uint64 post_outcome_price_d9 = 14;
   */
  postOutcomePriceD9?: bigint | undefined;

  /**
   * @generated from field: uint64 base_fee_to_backers_d6 = 15;
   */
  baseFeeToBackersD6: bigint;

  /**
   * @generated from field: optional uint64 execution_price_d9 = 16;
   */
  executionPriceD9?: bigint | undefined;

  /**
   * @generated from field: uint64 post_bc_supply_d6 = 17;
   */
  postBcSupplyD6: bigint;

  /**
   * Exact traded outcome mint and conviction observation clock bind the
   * immutable post-state to the corresponding snapshot outcome.
   *
   * @generated from field: string outcome_mint = 18;
   */
  outcomeMint: string;

  /**
   * @generated from field: int64 post_last_conviction_update_ts = 19;
   */
  postLastConvictionUpdateTs: bigint;
};

/**
 * Describes the message morfi.v1.MarketTrade.
 * Use `create(MarketTradeSchema)` to create a new message.
 */
export const MarketTradeSchema: GenMessage<MarketTrade> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 1);

/**
 * @generated from message morfi.v1.LeaderChangedEvent
 */
export type LeaderChangedEvent = Message<"morfi.v1.LeaderChangedEvent"> & {
  /**
   * @generated from field: morfi.v1.EventMetadata meta = 1;
   */
  meta?: EventMetadata | undefined;

  /**
   * @generated from field: bytes market = 2;
   */
  market: Uint8Array;

  /**
   * @generated from field: uint32 prev_argmax = 3;
   */
  prevArgmax: number;

  /**
   * @generated from field: bool prev_above_threshold = 4;
   */
  prevAboveThreshold: boolean;

  /**
   * @generated from field: uint64 prev_active_conviction_ppb = 5;
   */
  prevActiveConvictionPpb: bigint;

  /**
   * @generated from field: uint32 new_argmax = 6;
   */
  newArgmax: number;

  /**
   * @generated from field: bool new_above_threshold = 7;
   */
  newAboveThreshold: boolean;

  /**
   * @generated from field: uint64 new_active_conviction_ppb = 8;
   */
  newActiveConvictionPpb: bigint;

  /**
   * @generated from field: uint32 leader_share_bps = 9;
   */
  leaderShareBps: number;

  /**
   * @generated from field: uint32 conviction_reference_share_bps = 10;
   */
  convictionReferenceShareBps: number;

  /**
   * @generated from field: int64 ts = 11;
   */
  ts: bigint;
};

/**
 * Describes the message morfi.v1.LeaderChangedEvent.
 * Use `create(LeaderChangedEventSchema)` to create a new message.
 */
export const LeaderChangedEventSchema: GenMessage<LeaderChangedEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 2);

/**
 * @generated from message morfi.v1.MarketUserActivity
 */
export type MarketUserActivity = Message<"morfi.v1.MarketUserActivity"> & {
  /**
   * Opaque 15-byte big-endian ordering key.
   *
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: morfi.v1.MarketUserActivityKind kind = 3;
   */
  kind: MarketUserActivityKind;

  /**
   * @generated from field: morfi.v1.Side side = 4;
   */
  side: Side;

  /**
   * @generated from field: string actor = 5;
   */
  actor: string;

  /**
   * @generated from field: optional uint64 amount_d6 = 6;
   */
  amountD6?: bigint | undefined;

  /**
   * Traded outcome only: virtual quote + real quote reserves after the trade
   * (TradeEvent.post_quote_reserves). Same wire tag as the former
   * `post_reserves_d6` name — v0 subject unchanged.
   *
   * @generated from field: optional uint64 post_bc_quote_reserves_d6 = 7;
   */
  postBcQuoteReservesD6?: bigint | undefined;

  /**
   * Trade-only authoritative post-trade market-wide real quote reserves across
   * active outcomes. Absent on non-trade activity kinds. If absent or
   * malformed, SDKs preserve the cached exact REST total because per-outcome
   * reserves are virtual-only and cannot be summed to reconstruct this value.
   *
   * @generated from field: optional uint64 post_market_real_quote_reserves_d6 = 19;
   */
  postMarketRealQuoteReservesD6?: bigint | undefined;

  /**
   * @generated from field: optional uint32 outcome_idx = 8;
   */
  outcomeIdx?: number | undefined;

  /**
   * @generated from field: repeated uint32 post_outcome_conviction_ppb = 9;
   */
  postOutcomeConvictionPpb: number[];

  /**
   * @generated from field: repeated uint32 post_outcome_conviction_target_ppb = 10;
   */
  postOutcomeConvictionTargetPpb: number[];

  /**
   * @generated from field: optional uint32 post_conviction_retention_per_second_ppb = 11;
   */
  postConvictionRetentionPerSecondPpb?: number | undefined;

  /**
   * Per-trade prize-pool contribution (D6): the flat prize-pool fee
   * charged on every trade plus the conditional sell-penalty leg.
   * Frontend accumulates this into the running market prize pool.
   * Only set for trade activity.
   *
   * @generated from field: optional uint64 prize_pool_contribution_d6 = 13;
   */
  prizePoolContributionD6?: bigint | undefined;

  /**
   * On-chain transaction signature (base58), the activity's primary key.
   * The SDK realtime id-then-fetch prepend keys off this — `useGetTrades`
   * re-fetches the full trade row by signature on a `trade.v0` event.
   *
   * @generated from field: string signature = 14;
   */
  signature: string;

  /**
   * Post-trade SPOT price of the TRADED outcome (`outcome_idx`), D9
   * fixed-point — `post_quote_reserves / post_token_vault_reserves`.
   * Distinct from conviction (which drives resolution, not token value):
   * this is current spot state for charts and display. Executable Current
   * Value and PnL come from the shared full-position pool quote and must not
   * use spot-times-balance math. Pairs with `outcome_idx`, exactly like
   * `post_bc_quote_reserves_d6`. Only set for trade activity.
   *
   * @generated from field: optional uint64 post_outcome_price_d9 = 15;
   */
  postOutcomePriceD9?: bigint | undefined;

  /**
   * Market pubkey (base58). Also implicit in the market-user subject, but kept
   * in the payload for consumers such as the leaderboard's
   * `incrementUniqueMarket` helper.
   *
   * @generated from field: optional string market = 16;
   */
  market?: string | undefined;

  /**
   * Per-trade backer-fee vault contribution (D6) — the backers-side split
   * of every buy/sell base fee (default 50% of `fee_bps_buy` /
   * `fee_bps_sell_normal`). The frontend accumulates this into both the
   * running `backer_fee_vault_d6` and the lifetime
   * `total_backer_fees_collected_d6` counters on the
   * `useGetMarketBackerEarnings` cache row. Mirrors the contract's
   * on-chain `TradeEvent.base_fee_to_backers`. Set only for trade activity.
   *
   * @generated from field: optional uint64 base_fee_to_backers_d6 = 17;
   */
  baseFeeToBackersD6?: bigint | undefined;

  /**
   * Signed backer-share-mint balance delta in D6 (signed). Positive on
   * BACK (mint), negative on UNBACK (burn). Mirrors the on-chain
   * BackingEvent.shares_delta. The SDK adds this onto the
   * `useGetMarketBackerEarnings` cache row's `userShareD6` (when the
   * actor matches the connected wallet) and `supplyD6` (always) so the
   * pro-rata earnings projection stays accurate without a refetch.
   * Set only for backing activity (kind = BACK | UNBACK).
   *
   * @generated from field: optional sint64 shares_delta_d6 = 18;
   */
  sharesDeltaD6?: bigint | undefined;

  /**
   * Average execution price for the trade fact, D9 fixed-point —
   * `quote_amount_gross / bc_amount`. This is intentionally distinct from
   * `post_outcome_price_d9`: REST trade rows and historical price CAGGs keep
   * execution-price semantics while current outcome marks use post spot.
   *
   * @generated from field: optional uint64 execution_price_d9 = 20;
   */
  executionPriceD9?: bigint | undefined;

  /**
   * Exact post-trade outstanding BC outcome-token supply. This is the
   * contract TradeEvent's `bc_supply_after`; clients must not invert
   * post_bc_quote_reserves_d6 on SELL because ceil(K / token_reserve) is not
   * invertible.
   *
   * @generated from field: optional uint64 post_bc_supply_d6 = 21;
   */
  postBcSupplyD6?: bigint | undefined;

  /**
   * Exact Market.last_conviction_update_ts after max(previous,event clock).
   *
   * @generated from field: optional int64 post_last_conviction_update_ts = 22;
   */
  postLastConvictionUpdateTs?: bigint | undefined;

  /**
   * Exact traded outcome mint. Binds the absolute BC post-state payload to
   * the fetched market snapshot; outcome index alone is not an identity proof.
   *
   * @generated from field: optional string outcome_mint = 23;
   */
  outcomeMint?: string | undefined;
};

/**
 * Describes the message morfi.v1.MarketUserActivity.
 * Use `create(MarketUserActivitySchema)` to create a new message.
 */
export const MarketUserActivitySchema: GenMessage<MarketUserActivity> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 3);

/**
 * Post-commit Redis leaderboard row. Published by the asynchronous leaderboard
 * broadcaster after Redis writes finish and the broadcaster enriches the changed
 * wallet from Redis scores/ranks for the visible family/window row.
 *
 * @generated from message morfi.v1.LeaderboardRow
 */
export type LeaderboardRow = Message<"morfi.v1.LeaderboardRow"> & {
  /**
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * traders | boosters | backers
   *
   * @generated from field: string family = 2;
   */
  family: string;

  /**
   * 1d | 1w | 1m | 1y | lifetime
   *
   * @generated from field: string window = 3;
   */
  window: string;

  /**
   * base58 wallet member
   *
   * @generated from field: string wallet = 4;
   */
  wallet: string;

  /**
   * @generated from field: repeated string changed_metrics = 5;
   */
  changedMetrics: string[];

  /**
   * @generated from field: optional sint64 total_pnl = 6;
   */
  totalPnl?: bigint | undefined;

  /**
   * @generated from field: optional sint64 realized_pnl = 7;
   */
  realizedPnl?: bigint | undefined;

  /**
   * @generated from field: optional sint64 total_volume = 8;
   */
  totalVolume?: bigint | undefined;

  /**
   * @generated from field: optional sint64 total_trades = 9;
   */
  totalTrades?: bigint | undefined;

  /**
   * @generated from field: optional uint64 pnl_rank = 10;
   */
  pnlRank?: bigint | undefined;

  /**
   * @generated from field: optional uint64 volume_rank = 11;
   */
  volumeRank?: bigint | undefined;

  /**
   * @generated from field: optional uint64 trades_rank = 12;
   */
  tradesRank?: bigint | undefined;

  /**
   * @generated from field: optional sint64 total_amount_boosted = 13;
   */
  totalAmountBoosted?: bigint | undefined;

  /**
   * @generated from field: optional sint64 num_boosts = 14;
   */
  numBoosts?: bigint | undefined;

  /**
   * @generated from field: optional uint64 amount_rank = 15;
   */
  amountRank?: bigint | undefined;

  /**
   * @generated from field: optional uint64 boosts_rank = 16;
   */
  boostsRank?: bigint | undefined;

  /**
   * @generated from field: optional sint64 total_backed_net_d6 = 17;
   */
  totalBackedNetD6?: bigint | undefined;

  /**
   * @generated from field: optional sint64 num_backs = 18;
   */
  numBacks?: bigint | undefined;

  /**
   * @generated from field: optional uint64 backs_rank = 19;
   */
  backsRank?: bigint | undefined;
};

/**
 * Describes the message morfi.v1.LeaderboardRow.
 * Use `create(LeaderboardRowSchema)` to create a new message.
 */
export const LeaderboardRowSchema: GenMessage<LeaderboardRow> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 4);

/**
 * Burn-to-claim event on the backer-fee vault — published on
 * `morfi.market.{m}.backer_fee_claim.v0` (per-market, no actor segment;
 * claims are public market-wide updates that update everyone's
 * projection of the vault state). Mirrors the on-chain
 * `BackerFeeClaimedEvent` from `contracts/markets/programs/markets/src/
 * instructions/post_resolution/claim_backer_fees.rs:88-96`.
 *
 * The SDK realtime recipe on `useGetMarketBackerEarnings` uses these
 * snapshots authoritatively (SET, not delta) because the chain emits
 * the exact post-claim state on every claim — no need to integrate
 * deltas, the contract reports the truth.
 *
 * @generated from message morfi.v1.BackerFeeClaimEvent
 */
export type BackerFeeClaimEvent = Message<"morfi.v1.BackerFeeClaimEvent"> & {
  /**
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * base58
   *
   * @generated from field: string market = 3;
   */
  market: string;

  /**
   * base58 — wallet that burned shares
   *
   * @generated from field: string claimer = 4;
   */
  claimer: string;

  /**
   * backer-share tokens burned
   *
   * @generated from field: uint64 burn_amount_d6 = 5;
   */
  burnAmountD6: bigint;

  /**
   * USDC paid out from vault
   *
   * @generated from field: uint64 quote_payout_d6 = 6;
   */
  quotePayoutD6: bigint;

  /**
   * authoritative post-claim vault balance
   *
   * @generated from field: uint64 vault_balance_after_d6 = 7;
   */
  vaultBalanceAfterD6: bigint;

  /**
   * authoritative post-claim share-mint supply
   *
   * @generated from field: uint64 supply_after_d6 = 8;
   */
  supplyAfterD6: bigint;

  /**
   * base58 tx signature
   *
   * @generated from field: string signature = 9;
   */
  signature: string;
};

/**
 * Describes the message morfi.v1.BackerFeeClaimEvent.
 * Use `create(BackerFeeClaimEventSchema)` to create a new message.
 */
export const BackerFeeClaimEventSchema: GenMessage<BackerFeeClaimEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 5);

/**
 * Per-trade creator-fee accrual event. Published on
 * `morfi.user.{creator_wallet}.earnings.v0` by the indexer's trade
 * processor (BC only — `venue = 0`). The on-chain `TradeEvent` carries
 * `base_fee_to_backers` (the backer-fee pool contribution); the creator's
 * share is `base_fee_to_backers × creator_share_ppb / 1e9`, with
 * `creator_share_ppb` resolved from the per-market `BackerFeeShareConfig`
 * state the indexer already maintains. Drives live "Earnings" on the
 * creators leaderboard.
 *
 * @generated from message morfi.v1.UserEarningsEvent
 */
export type UserEarningsEvent = Message<"morfi.v1.UserEarningsEvent"> & {
  /**
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * creator wallet (base58)
   *
   * @generated from field: string actor = 3;
   */
  actor: string;

  /**
   * creator's share of base_fee_to_backers (D6)
   *
   * @generated from field: uint64 amount_d6 = 4;
   */
  amountD6: bigint;

  /**
   * source market pubkey (base58)
   *
   * @generated from field: string market = 5;
   */
  market: string;

  /**
   * originating trade signature (base58)
   *
   * @generated from field: string signature = 6;
   */
  signature: string;
};

/**
 * Describes the message morfi.v1.UserEarningsEvent.
 * Use `create(UserEarningsEventSchema)` to create a new message.
 */
export const UserEarningsEventSchema: GenMessage<UserEarningsEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 6);

/**
 * Private viewer-only invalidation signal. The opaque version lets clients
 * refetch protected state without disclosing the changed target or relation.
 *
 * @generated from message morfi.v1.ContentSafetyVersionEvent
 */
export type ContentSafetyVersionEvent = Message<"morfi.v1.ContentSafetyVersionEvent"> & {
  /**
   * @generated from field: string content_safety_version = 1;
   */
  contentSafetyVersion: string;
};

/**
 * Describes the message morfi.v1.ContentSafetyVersionEvent.
 * Use `create(ContentSafetyVersionEventSchema)` to create a new message.
 */
export const ContentSafetyVersionEventSchema: GenMessage<ContentSafetyVersionEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 7);

/**
 * @generated from message morfi.v1.MarketLifecycle
 */
export type MarketLifecycle = Message<"morfi.v1.MarketLifecycle"> & {
  /**
   * Opaque 15-byte big-endian ordering key.
   *
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: morfi.v1.LifecycleKind kind = 3;
   */
  kind: LifecycleKind;

  /**
   * @generated from field: optional uint32 leader = 4;
   */
  leader?: number | undefined;

  /**
   * Market pubkey (base58). Implicit in the per-market routing key
   * (`morfi.market.${market}.lifecycle.v0`), but the SDK's id-then-fetch
   * prepend recipe needs the id INSIDE the payload to drive its batched
   * fetch on graduation. Same shape as MarketCreatedNotification.market.
   *
   * @generated from field: string market = 5;
   */
  market: string;
};

/**
 * Describes the message morfi.v1.MarketLifecycle.
 * Use `create(MarketLifecycleSchema)` to create a new message.
 */
export const MarketLifecycleSchema: GenMessage<MarketLifecycle> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 8);

/**
 * Broadcast (no per-market routing key) fired when a market graduates, so a
 * graduated-markets feed can id-then-fetch prepend the new row without
 * pre-subscribing to the market's per-market lifecycle subject. Mirrors
 * MarketCreatedNotification — carries only the new-row id.
 *
 * @generated from message morfi.v1.MarketGraduatedNotification
 */
export type MarketGraduatedNotification = Message<"morfi.v1.MarketGraduatedNotification"> & {
  /**
   * Opaque 15-byte big-endian ordering key.
   *
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: string market = 3;
   */
  market: string;
};

/**
 * Describes the message morfi.v1.MarketGraduatedNotification.
 * Use `create(MarketGraduatedNotificationSchema)` to create a new message.
 */
export const MarketGraduatedNotificationSchema: GenMessage<MarketGraduatedNotification> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 9);

/**
 * Terminal resolution event — published on `morfi.market.{m}.resolution.v0`
 * (per-market, public). Split off MarketLifecycle so resolution-specific PnL
 * data isn't carried on the generic market-activity channel. The market id is
 * repeated from the subject so SDK list-prepend recipes can batch-fetch the
 * resolved row without parsing subject tokens in generated cache code.
 *
 * Frontend keys token balances by mint: on receipt it (1) flips the market row
 * status to 'resolved' and sets the final prize pool, and (2) realizes any
 * non-winning holding the wallet still holds as sold-for-0 (= -cost_basis) —
 * client-side loss derivation (future consumer).
 *
 * @generated from message morfi.v1.MarketResolved
 */
export type MarketResolved = Message<"morfi.v1.MarketResolved"> & {
  /**
   * opaque 15-byte big-endian ordering key
   *
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * winning outcome mint (base58) — matches the publish-message family (MarketLifecycle.market, MarketTrade.actor); bytes is reserved for raw Borsh chain-event mirrors
   *
   * @generated from field: string winning_mint = 3;
   */
  winningMint: string;

  /**
   * final prize-pool snapshot (D6); always present at resolution
   *
   * @generated from field: uint64 prize_pool_d6 = 4;
   */
  prizePoolD6: bigint;

  /**
   * market pubkey (base58), duplicated from the subject for SDK id-then-fetch prepend
   *
   * @generated from field: string market = 5;
   */
  market: string;

  /**
   * winning outcome's final D9 conviction snapshot; always present
   *
   * @generated from field: uint32 winning_conviction_at_resolution_ppb = 6;
   */
  winningConvictionAtResolutionPpb: number;
};

/**
 * Describes the message morfi.v1.MarketResolved.
 * Use `create(MarketResolvedSchema)` to create a new message.
 */
export const MarketResolvedSchema: GenMessage<MarketResolved> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 10);

/**
 * @generated from message morfi.v1.MarketCreatedOutcome
 */
export type MarketCreatedOutcome = Message<"morfi.v1.MarketCreatedOutcome"> & {
  /**
   * @generated from field: uint32 idx = 1;
   */
  idx: number;

  /**
   * @generated from field: string mint = 2;
   */
  mint: string;

  /**
   * @generated from field: string uri = 3;
   */
  uri: string;

  /**
   * @generated from field: string prize_rights_mint = 4;
   */
  prizeRightsMint: string;
};

/**
 * Describes the message morfi.v1.MarketCreatedOutcome.
 * Use `create(MarketCreatedOutcomeSchema)` to create a new message.
 */
export const MarketCreatedOutcomeSchema: GenMessage<MarketCreatedOutcome> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 11);

/**
 * @generated from message morfi.v1.MarketCreatedNotification
 */
export type MarketCreatedNotification = Message<"morfi.v1.MarketCreatedNotification"> & {
  /**
   * Opaque 15-byte big-endian ordering key.
   *
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: string market = 3;
   */
  market: string;

  /**
   * @generated from field: string creator = 4;
   */
  creator: string;

  /**
   * @generated from field: string category = 5;
   */
  category: string;

  /**
   * @generated from field: string meta_uri = 6;
   */
  metaUri: string;

  /**
   * @generated from field: repeated morfi.v1.MarketCreatedOutcome outcomes = 7;
   */
  outcomes: MarketCreatedOutcome[];
};

/**
 * Describes the message morfi.v1.MarketCreatedNotification.
 * Use `create(MarketCreatedNotificationSchema)` to create a new message.
 */
export const MarketCreatedNotificationSchema: GenMessage<MarketCreatedNotification> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 12);

/**
 * @generated from message morfi.v1.GiftEvent
 */
export type GiftEvent = Message<"morfi.v1.GiftEvent"> & {
  /**
   * Opaque 15-byte big-endian ordering key.
   *
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: morfi.v1.GiftEventKind kind = 3;
   */
  kind: GiftEventKind;

  /**
   * @generated from field: string gift_config = 4;
   */
  giftConfig: string;

  /**
   * @generated from field: string mint = 5;
   */
  mint: string;

  /**
   * @generated from field: uint64 amount_d6 = 6;
   */
  amountD6: bigint;

  /**
   * Set on GIFT_EVENT_KIND_CLAIMED — the recipient wallet (base58).
   *
   * @generated from field: optional string claimer = 7;
   */
  claimer?: string | undefined;

  /**
   * SENT/RECEIVED, populated on the per-user dual-publish
   * (`morfi.user.{u}.gift.v0`). UNSPECIFIED on the public gift-keyed
   * subject.
   *
   * @generated from field: morfi.v1.GiftDirection direction = 8;
   */
  direction: GiftDirection;

  /**
   * The on-chain Gift PDA (base58) — primary key of the App-DB `gifts`
   * table and the realtime row id.
   *
   * @generated from field: string gift_pda = 9;
   */
  giftPda: string;

  /**
   * Server-generated 32-char hex (128-bit) opaque id powering shareable
   * permalink URLs. Carried on the event so the SDK's
   * `useGetGiftsPermalink` set-recipe can match without a follow-up REST.
   *
   * @generated from field: string opaque_id = 10;
   */
  opaqueId: string;

  /**
   * Asset kind — mirrors the on-chain GiftKind enum. Drives the
   * declarative `prepend` recipe in the SDK: USDC vs outcome_token vs
   * prize_pool_share have different row-render paths.
   *
   * @generated from field: morfi.v1.GiftKind asset_kind = 11;
   */
  assetKind: GiftKind;

  /**
   * Off-chain handle the gift was addressed to. Lets the row helper
   * render the inbox without joining `users`.
   *
   * @generated from field: string recipient_handle = 12;
   */
  recipientHandle: string;

  /**
   * 'morfi' | 'x'.
   *
   * @generated from field: string recipient_platform = 13;
   */
  recipientPlatform: string;

  /**
   * Display handle for the sender. Empty string when anonymous (the
   * helper substitutes "Anonymous Morfian").
   *
   * @generated from field: string sender_handle = 14;
   */
  senderHandle: string;

  /**
   * User-supplied message (≤140 chars). Empty when none / anonymous.
   *
   * @generated from field: string message = 15;
   */
  message: string;
};

/**
 * Describes the message morfi.v1.GiftEvent.
 * Use `create(GiftEventSchema)` to create a new message.
 */
export const GiftEventSchema: GenMessage<GiftEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 13);

/**
 * Thesis activity (debate entries) on a market. Unlike the other v0
 * messages here, ThesisEvent is API-published, not indexer-published:
 * theses are user-authored content created/reacted/replied via
 * backend-api-service write routes, which publish this message on
 * `morfi.market.${m}.thesis.v0` after a successful write.
 *
 * @generated from message morfi.v1.ThesisEvent
 */
export type ThesisEvent = Message<"morfi.v1.ThesisEvent"> & {
  /**
   * Opaque 15-byte big-endian ordering key.
   *
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: morfi.v1.ThesisEventKind kind = 3;
   */
  kind: ThesisEventKind;

  /**
   * Transaction signature of the originating trade — the thesis primary key.
   *
   * @generated from field: string signature = 4;
   */
  signature: string;

  /**
   * @generated from field: string market_pubkey = 5;
   */
  marketPubkey: string;

  /**
   * @generated from field: string author_id = 6;
   */
  authorId: string;
};

/**
 * Describes the message morfi.v1.ThesisEvent.
 * Use `create(ThesisEventSchema)` to create a new message.
 */
export const ThesisEventSchema: GenMessage<ThesisEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 14);

/**
 * Notification event — see `UserNotificationKind` doc. API-published on
 * `morfi.user.{recipient_user_id}.notifications.v0`. Carries the embedded
 * profile fields the SDK needs to prepend a row onto a followers list
 * without a follow-up REST fetch (the followers list cache is patched
 * in place by `buildFollowerNotificationFromEvent`).
 *
 * @generated from message morfi.v1.UserNotification
 */
export type UserNotification = Message<"morfi.v1.UserNotification"> & {
  /**
   * Opaque 15-byte big-endian ordering key.
   *
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: morfi.v1.UserNotificationKind kind = 3;
   */
  kind: UserNotificationKind;

  /**
   * FOLLOW_RECEIVED: the user who followed `recipient_user_id`. Embedded
   * profile fields so the followers-list cache can prepend without a
   * round-trip REST fetch.
   *
   * @generated from field: optional string follower_user_id = 4;
   */
  followerUserId?: string | undefined;

  /**
   * @generated from field: optional string follower_display_name = 5;
   */
  followerDisplayName?: string | undefined;

  /**
   * @generated from field: optional string follower_handle = 6;
   */
  followerHandle?: string | undefined;

  /**
   * @generated from field: optional string follower_avatar_url = 7;
   */
  followerAvatarUrl?: string | undefined;

  /**
   * @generated from field: optional bool follower_avatar_nsfw = 8;
   */
  followerAvatarNsfw?: boolean | undefined;
};

/**
 * Describes the message morfi.v1.UserNotification.
 * Use `create(UserNotificationSchema)` to create a new message.
 */
export const UserNotificationSchema: GenMessage<UserNotification> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_trading, 15);

/**
 * @generated from enum morfi.v1.MarketUserActivityKind
 */
export enum MarketUserActivityKind {
  /**
   * @generated from enum value: MARKET_USER_ACTIVITY_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MARKET_USER_ACTIVITY_KIND_TRADE = 1;
   */
  TRADE = 1,

  /**
   * @generated from enum value: MARKET_USER_ACTIVITY_KIND_BACK = 2;
   */
  BACK = 2,

  /**
   * @generated from enum value: MARKET_USER_ACTIVITY_KIND_BOOST = 3;
   */
  BOOST = 3,

  /**
   * @generated from enum value: MARKET_USER_ACTIVITY_KIND_UNBACK = 4;
   */
  UNBACK = 4,

  /**
   * Resolved-market prize-claim instruction. Subject:
   * `morfi.market.${m}.user.{actor}.claim.v0`. `outcome_idx` identifies
   * the winning outcome; `amount_d6` is the claimed prize amount.
   *
   * @generated from enum value: MARKET_USER_ACTIVITY_KIND_CLAIM = 5;
   */
  CLAIM = 5,
}

/**
 * Describes the enum morfi.v1.MarketUserActivityKind.
 */
export const MarketUserActivityKindSchema: GenEnum<MarketUserActivityKind> = /*@__PURE__*/
  enumDesc(file_morfi_v1_markets_trading, 0);

/**
 * Notification event delivered to a user's PRIVATE feed
 * `morfi.user.{recipient_user_id}.notifications.v0`. PRIVATE channel
 * (allowSub `authedExtra`). API-PUBLISHED (off-chain — backend-api emits
 * on follow / system events). The single carve-out from the
 * indexer-only-publisher rule, parallel to the theses publisher carve-out.
 *
 * @generated from enum morfi.v1.UserNotificationKind
 */
export enum UserNotificationKind {
  /**
   * @generated from enum value: USER_NOTIFICATION_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Another user followed this account. SDK +followersCount and prepends
   * a follower row built from the embedded follower profile fields.
   *
   * @generated from enum value: USER_NOTIFICATION_KIND_FOLLOW_RECEIVED = 1;
   */
  FOLLOW_RECEIVED = 1,
}

/**
 * Describes the enum morfi.v1.UserNotificationKind.
 */
export const UserNotificationKindSchema: GenEnum<UserNotificationKind> = /*@__PURE__*/
  enumDesc(file_morfi_v1_markets_trading, 1);

/**
 * @generated from enum morfi.v1.LifecycleKind
 */
export enum LifecycleKind {
  /**
   * @generated from enum value: LIFECYCLE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LIFECYCLE_KIND_BACKING_STARTED = 1;
   */
  BACKING_STARTED = 1,

  /**
   * @generated from enum value: LIFECYCLE_KIND_TRADING_STARTED = 2;
   */
  TRADING_STARTED = 2,

  /**
   * @generated from enum value: LIFECYCLE_KIND_LEADER_CHANGED = 3;
   */
  LEADER_CHANGED = 3,

  /**
   * Retained for wire compatibility (old kind=4 messages must still
   * deserialize), but NO LONGER EMITTED by the indexer — resolution moved to
   * its own subject `morfi.market.{m}.resolution.v0` carrying MarketResolved.
   *
   * @generated from enum value: LIFECYCLE_KIND_RESOLUTION = 4;
   */
  RESOLUTION = 4,

  /**
   * @generated from enum value: LIFECYCLE_KIND_GRADUATION = 5;
   */
  GRADUATION = 5,

  /**
   * Settlement changes the remaining prize valuation without changing status.
   *
   * @generated from enum value: LIFECYCLE_KIND_PRIZE_POOL_DRAINED = 6;
   */
  PRIZE_POOL_DRAINED = 6,

  /**
   * @generated from enum value: LIFECYCLE_KIND_PRIZE_CLAWBACK = 7;
   */
  PRIZE_CLAWBACK = 7,
}

/**
 * Describes the enum morfi.v1.LifecycleKind.
 */
export const LifecycleKindSchema: GenEnum<LifecycleKind> = /*@__PURE__*/
  enumDesc(file_morfi_v1_markets_trading, 2);

/**
 * @generated from enum morfi.v1.GiftEventKind
 */
export enum GiftEventKind {
  /**
   * @generated from enum value: GIFT_EVENT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GIFT_EVENT_KIND_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: GIFT_EVENT_KIND_CLAIMED = 2;
   */
  CLAIMED = 2,
}

/**
 * Describes the enum morfi.v1.GiftEventKind.
 */
export const GiftEventKindSchema: GenEnum<GiftEventKind> = /*@__PURE__*/
  enumDesc(file_morfi_v1_markets_trading, 3);

/**
 * Routing direction for a per-user gift event dual-publish. The same
 * underlying chain event is published twice on `morfi.user.{u}.gift.v0`
 * — once to the recipient with `direction = RECEIVED` and once to the
 * sender with `direction = SENT`. Lets the SDK's `applyPendingCountDelta`
 * helper apply pending-count deltas only on the recipient side without a
 * second NATS subject.
 *
 * @generated from enum morfi.v1.GiftDirection
 */
export enum GiftDirection {
  /**
   * @generated from enum value: GIFT_DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GIFT_DIRECTION_SENT = 1;
   */
  SENT = 1,

  /**
   * @generated from enum value: GIFT_DIRECTION_RECEIVED = 2;
   */
  RECEIVED = 2,
}

/**
 * Describes the enum morfi.v1.GiftDirection.
 */
export const GiftDirectionSchema: GenEnum<GiftDirection> = /*@__PURE__*/
  enumDesc(file_morfi_v1_markets_trading, 4);

/**
 * @generated from enum morfi.v1.ThesisEventKind
 */
export enum ThesisEventKind {
  /**
   * @generated from enum value: THESIS_EVENT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: THESIS_EVENT_KIND_POSTED = 1;
   */
  POSTED = 1,

  /**
   * @generated from enum value: THESIS_EVENT_KIND_EDITED = 2;
   */
  EDITED = 2,

  /**
   * @generated from enum value: THESIS_EVENT_KIND_DELETED = 3;
   */
  DELETED = 3,

  /**
   * @generated from enum value: THESIS_EVENT_KIND_REACTION = 4;
   */
  REACTION = 4,

  /**
   * @generated from enum value: THESIS_EVENT_KIND_REPLY = 5;
   */
  REPLY = 5,
}

/**
 * Describes the enum morfi.v1.ThesisEventKind.
 */
export const ThesisEventKindSchema: GenEnum<ThesisEventKind> = /*@__PURE__*/
  enumDesc(file_morfi_v1_markets_trading, 5);

